export default {
  "tab.title": "Review",
  "tab.count.one": "{{count}} file changed",
  "tab.count.other": "{{count}} files changed",
  "mobile.title.one": "Change",
  "mobile.title.other": "Changes",
  "empty.git": "No uncommitted changes yet",
  "empty.branch": "No branch changes yet",
  "git.title": "Create a Git repository",
  "git.description": "Track, review, and undo changes in this project",
  loadingChanges: "Loading changes…",
  noChanges: "No changes",
  "settings.wrapLines.title": "Wrap lines",
  "settings.wrapLines.description": "Wrap long lines in mobile diffs instead of scrolling horizontally",
}
